import accountConstants from '../actiontypes/account';

const initialState = {
  list: [],
  loading: false,
  updatingAccounts: false,
  available: false
};

function account(state = initialState, action) {
  switch (action.type) {
    case accountConstants.LIST_ACCOUNTS_REQUEST:
      return { ...state, loading: true };
    case accountConstants.LIST_ACCOUNTS_SUCCESS:
      return { ...state, list: action.payload, loading: false, unexpectedError: false };
    case accountConstants.LIST_ACCOUNTS_FAILURE:
      return { ...state, list: [], loading: false };
    case accountConstants.UPDATE_ACCOUNTS_REQUEST:
      return { ...state, updatingAccounts: true };
    case accountConstants.UPDATE_ACCOUNTS_SUCCESS:
      return { ...state, list: action.payload, updatingAccounts: false };
    case accountConstants.UPDATE_ACCOUNTS_FAILURE:
      return { ...state, list: [], updatingAccounts: false };
    case accountConstants.VALIDATE_ACCOUNT_REQUEST:
      return { ...state, loading: true };
    case accountConstants.VALIDATE_ACCOUNT_SUCCESS:
      return { ...state, available: action.payload.available, loading: false };
    case accountConstants.VALIDATE_ACCOUNT_FAILURE:
      return { ...state, available: false, loading: false };
    default:
      return state;
  }
}

export default account;
